const stripTrailingSlash = (path) => path.replace(/\/$/, '');

export const stripLocale = (path, locale) => {
  if (!path) {
    return '';
  }

  path = stripTrailingSlash(path);

  if (locale === 'en') {
    if (!path.startsWith('/')) {
      console.info('path should have leading slash');
      return path;
    }

    return path.substring(1);
  } else {
    const match = path.match(/^(\/[a-z]{2}(-[a-z]{2})?)(\/|$)/);

    if (!match) {
      console.info('path should be prefixed with locale and leading slash', path);
      return path;
    }

    return path.replace(match[0], '');
  }
};

/**
 *
 * A function that maps a complex locale like ch-fr or ch-de to a basic locale
 *
 * @param {String} locale
 */
export const mapToBasicLocale = (locale) => {
  if (locale === 'ch-fr') {
    return 'fr';
  } else if (locale === 'ch-de') {
    return 'de';
  } else {
    return locale;
  }
};
